import { useCallback, useRef, useState } from "react"

import TikTokPixelsTab from "./TikTokPixelsTab"
import KlowPixelsTab from "./KlowPixelsTab"

type PixelSection = "tiktok" | "klow"

export default function PixelsTab() {
  const [section, setSection] = useState<PixelSection>("tiktok")
  const [search, setSearch] = useState("")
  const openCreateRef = useRef<(() => void) | null>(null)

  const registerOpenCreate = useCallback((fn: (() => void) | null) => {
    openCreateRef.current = fn
  }, [])

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col gap-4 overflow-hidden">
      <div className="flex shrink-0 flex-wrap items-center gap-2">
        <div className="flex flex-wrap gap-2">
          {(
            [
              ["tiktok", "TikTok (ADW)"],
              ["klow", "KLOW (RSOC spid)"],
            ] as const
          ).map(([id, label]) => (
            <button
              key={id}
              type="button"
              onClick={() => setSection(id)}
              className={`h-8 rounded-md px-3 text-xs font-semibold transition-colors ${
                section === id
                  ? "border border-[#8fa0ef]/35 bg-[#7488e8] text-white"
                  : "border border-[#555] bg-[#2d2d2d] text-[#b0b0b0] hover:text-white"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
        <input
          type="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={
            section === "tiktok"
              ? "Search by name, pixel ID, owner…"
              : "Search by name, spid, code, buyer…"
          }
          aria-label="Search pixels"
          className="h-8 min-w-[180px] flex-1 rounded-md border border-[#555] bg-[#2d2d2d] px-3 text-xs text-white placeholder:text-[#888] outline-none focus:border-[#8b9aff]"
        />
        <button
          type="button"
          onClick={() => openCreateRef.current?.()}
          className="h-8 shrink-0 rounded-md border border-[#8fa0ef]/35 bg-[#7488e8] px-3 text-xs font-semibold text-white shadow-sm transition-colors hover:bg-[#687bda]"
        >
          {section === "tiktok" ? "+ Create Pixel" : "+ Create KLOW Pixel"}
        </button>
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {section === "tiktok" ? (
          <TikTokPixelsTab
            search={search}
            registerOpenCreate={registerOpenCreate}
          />
        ) : (
          <KlowPixelsTab
            search={search}
            registerOpenCreate={registerOpenCreate}
          />
        )}
      </div>
    </div>
  )
}
